export default {
  install(Vue, options = {}) {
    const {
      maxBackgroundMs = 30 * 60 * 1000,
      storageKey = "app:last_refreshed_at"
    } = options;

    const refreshedAt = Date.now();
    let wasHidden = false;
    let reloading = false;

    // Contar desde a abertura, independentemente do resultado das requisições.
    try { sessionStorage.removeItem("app:last_hidden_at"); } catch (e) {}
    try { sessionStorage.setItem(storageKey, String(refreshedAt)); } catch (e) {}

    function markHidden() {
      wasHidden = true;
    }

    function handleReturn() {
      if (document.visibilityState === "hidden" || !wasHidden || reloading) return;
      wasHidden = false;

      let lastRefreshedAt = refreshedAt;
      try {
        const storedAt = Number(sessionStorage.getItem(storageKey));
        if (Number.isFinite(storedAt) && storedAt > 0) lastRefreshedAt = storedAt;
      } catch (e) {}

      if (Date.now() - lastRefreshedAt >= maxBackgroundMs) {
        reloading = true;
        window.location.reload();
      }
    }

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") markHidden();
      else handleReturn();
    });
    window.addEventListener("pagehide", markHidden);
    window.addEventListener("pageshow", handleReturn);
    window.addEventListener("focus", handleReturn);

    Vue.prototype.$bgReload = {markHidden, handleReturn};
  }
};
